export enum SecurityDomain {
    MODMED = 'MODMED',
    EYEFINITY = 'EYEFINITY'
}
